import { configureStore } from '@reduxjs/toolkit'
import authReducer from './authSlice'
import roomsReducer from './roomsSlice'
import matchesReducer from './matchesSlice'
import invitationsReducer from './invitationsSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    rooms: roomsReducer,
    matches: matchesReducer,
    invitations: invitationsReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
